// extracted by mini-css-extract-plugin
export var hero = "singleImage-module--hero--29c4b";
export var image = "singleImage-module--image--7f987";
export var subtitle = "singleImage-module--subtitle--96dc6";
export var wrapper = "singleImage-module--wrapper--7332b";